import { WondeSyncMismatch } from "@core/models/domain/wonde-sync.domain";

export interface WondeSyncState {
  mismatches: WondeSyncMismatch[];
  /** Records the school skipped, kept apart so the pending count (badge) is unchanged. */
  skippedMismatches: WondeSyncMismatch[];
  /** Set when the skipped list cannot be read; kept apart so the pending list and its banner are unaffected. */
  skippedError: string | null;
  loading: boolean;
  error: string | null;
  // Id of the record currently being decided, so the page can disable that card's buttons.
  actionInProgressId: string | null;
}

export const initialWondeSyncState: WondeSyncState = {
  mismatches: [],
  skippedMismatches: [],
  skippedError: null,
  loading: false,
  error: null,
  actionInProgressId: null,
};
